module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChapNumber"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "ch3"
    }
  }, [_vm._v("CHAPTER 3")])]), _c('a', {
    attrs: {
      "id": "ch3"
    }
  }, [_c('p', {
    staticClass: "ChapTitle"
  }, [_vm._v("DIETING AND INVESTING")]), _vm._v(" "), _c('p', {
    staticClass: "CST"
  }, [_c('em', [_vm._v("A Broad Range of Ingredients Keeps Your Portfolio Healthy")])]), _vm._v(" "), _c('p', {
    staticClass: "DropCap"
  }, [_vm._v("There are a lot of people whose eyes glaze over every time they even think about investing. All those numbers and terms and graphs . . . they neither have an interest nor perhaps an ability to grasp abstract concepts easily. I recall learning from a colleague in education that something like 85 percent of people have difficulty thinking conceptually. After all, investments are not something you can smell or touch or kick. To many people using numbers to symbolize anything is like taking high school algebra all over again.")])]), _c('p', {
    staticClass: "TextInd"
  }, [_c('a', {
    attrs: {
      "id": "ch3"
    }
  }, [_vm._v("In the finance and investment industry, however, there is a concentration of people who relish thinking in numbers or thinking conceptually. When people in our industry explain financial terms and concepts, they don’t realize many of their clients actually don’t like being there, having to listen to something they think is boring. I remember once working at Tyndall, a major investments company in Sydney, Australia that takes a lot of care in investor education. One of the novice investors said to me, “When I walk into a broker or a bank, to me, it is like going to the dentist to get a tooth drilled, or ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("worse, going to a proctologist!” But since we in the industry don’t share that feeling, we often overlook the idea that our lectures don’t help many people.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Perhaps it was best said to me by a great manager in a local Asian bank: “Just give me a product where none of the explanations have even as much as one detailed graph in it. My clients hate it and complicated graphs even scare a lot of my staff.” It was a revelatory moment for me as I realized just how much more work we need to do in the area of communication with investors. Otherwise, no matter how brilliant our strategies, the average investor won’t benefit from the basic tools of investing if they can’t easily identify with them.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Fortunately, there are excellent examples outside of investing that can help people get more comfortable with our basic concepts. For instance, many of the principles of a good diet, surprisingly, turn out to be the same principles needed for a good investment portfolio.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Over the last decade, diet experts and food scientists have discovered much about what our bodies need. The human body and brain do much better when we have a very broad diet—much broader than was realized before. As many people now know, it turns out that a natural mixture of “old-fashioned” meals our grandmothers made often deliver the broad diet that is so good for our health. For instance, when one takes a vitamin E tablet once a day, it is too narrow or too focused in only one subtype of vitamin E."), _c('sup', [_c('a', {
    attrs: {
      "id": "fbn1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9781137279101_22_not#ifbn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" A broad diet, however, inherently gives us a nearly infinite variety of vitamin E subtypes. It’s the same story with chia, which is high in omega-3, notably valuable for our brain health. Yet we only need to eat a small amount of chia seeds throughout the year to capture this form of omega-3 without adding a lot of extra food to our diet."), _c('sup', [_c('a', {
    attrs: {
      "id": "fbn2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9781137279101_22_not#ifbn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("With investing, a very broadly diversified portfolio does much better for investors over their lifetimes and keeps the annual volatility lower. And just like the chia seeds, very small percentages of your portfolio in relatively discreet asset classes can be helpful to your long-term performance and to decreasing annual volatility.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Let’s look at just such an example for your portfolio. Gold as an investment, from the early eighties until this past decade, was a terrible performer.")]), _vm._v(" "), _c('p', {
    staticClass: "Fig_Capt"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "ch3-fig_3-1"
    }
  }, [_c('strong', [_vm._v("Fig. 3.1")]), _vm._v("   Gold Price ($/oz) Since 1931")])]), _c('a', {
    attrs: {
      "id": "ch3-fig_3-1"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "326",
      "src": "html/images/fig3.1.jpg",
      "width": "534"
    }
  })])]), _c('p', {
    staticClass: "TabCapt"
  }, [_c('a', {
    attrs: {
      "id": "ch3-fig_3-1"
    }
  }, [_c('strong')]), _c('strong', [_c('a', {
    attrs: {
      "id": "ch3-tab_3-1"
    }
  }, [_vm._v("Table 3.1")])]), _c('a', {
    attrs: {
      "id": "ch3-tab_3-1"
    }
  }, [_vm._v("   Gold Prices (1980–2012)")])]), _c('a', {
    attrs: {
      "id": "ch3-tab_3-1"
    }
  }, [_c('p', {
    staticClass: "image-tab"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "88",
      "src": "html/images/tab3.1.jpg",
      "width": "498"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("However, gold stores value, and if a person only had 5 percent of his portfolio in gold, it would have substantially decreased the loss in his overall portfolio in recent years. In essence, gold had the “chia seeds effect.”")])]), _c('p', {
    staticClass: "TextInd"
  }, [_c('a', {
    attrs: {
      "id": "ch3-tab_3-1"
    }
  }, [_vm._v("Food, just like investing, can often be a very emotional topic. Since I was a child, I have lived and worked in over 40 countries. It has always amazed me how in one country people will love a dish that in another country would be considered wholly unappetizing. In countries around the world I have continually noticed that men often are not as interested in trying new foods when they have a choice. They would just as soon eat their local food, like noodles, the “comfort” foods their moms often served them when they were young. Women, on the other hand, are much more likely to be adventurous in exotic cuisine. When you see local men in a fancy Western restaurant in Asia, they are either on a date trying to please ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("their partner or entertaining a Westerner for business purposes. Like investing, it is often hard to get people to try different things they are not used to. I recall laughing along with a Chinese business partner who said that whenever he hears his Chinese compatriots arguing in restaurants, he knows that it is likely about differing views of types of Chinese food. “China would be more advanced,” he complained, “if we didn’t argue and obsess so much about different styles of cooking.”")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("As you will see in coming chapters, just like with food, one’s prejudices are often buried deep into why one either likes or despises one asset class over another.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "BOXTitle"
  }, [_c('strong', [_vm._v("THE LESSONS I LEARNED FROM DIETS")])]), _vm._v(" "), _c('p', {
    staticClass: "BOXNList"
  }, [_c('strong', [_c('span', {
    staticClass: "ClassList"
  }, [_vm._v("1.")]), _c('span', {
    staticClass: "disp"
  }), _vm._v("Invest for life.")]), _vm._v(" A portfolio that contains a broad array of truly different types of investments and asset classes is often better for investors throughout their lives."), _c('sup', [_c('a', {
    attrs: {
      "id": "fbn3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9781137279101_22_not#ifbn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "BOXNList"
  }, [_c('strong', [_c('span', {
    staticClass: "ClassList"
  }, [_vm._v("2.")]), _c('span', {
    staticClass: "disp"
  }), _vm._v("Even an asset class that has underperformed for years, just like gold, can still help in lessening the volatility of the total portfolio.")])]), _vm._v(" "), _c('p', {
    staticClass: "BOXNList"
  }, [_c('strong', [_c('span', {
    staticClass: "ClassList"
  }, [_vm._v("3.")]), _c('span', {
    staticClass: "disp"
  }), _vm._v("Broccoli is good for you.")]), _vm._v(" Just like food, there are some types of investments you may not like, but still, having a little in your portfolio can be good for your long-term financial health.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49d9630e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781137279101_04_ch03.vue
// module id = 66
// module chunks = 0